import React from "react";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { useLanguage } from "hooks";
import { Layout } from "components";
import Nav from "../Nav";

/**
 * first page in profile that display user data from user object user in auth store
 * show data like a form but disabled
 */

export default function Edit() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { user } = useSelector((state) => state.auth); // call data from auth store

  return (
    <Layout>
      <section id="profile" className="mb-3">
        <Container>
          {user !== null && (
            <>
              {" "}
              <Row>
                <Col xs={12}>
                  <h1 className="text-primary fw-bold">{language.profile}</h1>
                </Col>
              </Row>
              <Row className="mt-4 mt-4 mt-4 ">
                {/* Right */}
                <Col xl={3} lg={3} md={5} sm={12} xs={12} className="order-1">
                  <Nav />
                </Col>

                <Col xl={1} lg={1} xs={0} className="order-lg-2 order-3"></Col>

                {/* Left */}
                <Col
                  xl={7}
                  lg={7}
                  md={7}
                  sm={12}
                  xs={12}
                  className=" mt-4 mt-md-0 order-lg-3 order-2"
                >
                  <Row className="mb-0 mb-lg-4">
                    <Col xl={6} lg={6} className="mt-3 mt-md-0">
                      <label
                        htmlFor="first_name"
                        className="form-label text-light5"
                      >
                        {language.fullName}
                      </label>
                      <input
                        type="text"
                        id="first_name"
                        className="form-control rounded-3"
                        placeholder="محمد"
                        value={user?.name}
                        required
                        disabled
                      />
                    </Col>
                    <Col xl={6} lg={6} className="mt-3 mt-md-0">
                      <label htmlFor="email" className="form-label text-light5">
                        {language.emailAddress}
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control rounded-3"
                        placeholder="johndoe@example.com"
                        value={user?.email}
                        required
                        disabled
                      />
                    </Col>
                    <Col xl={6} lg={6} className="mt-3">
                      <label
                        htmlFor="branch"
                        className="form-label text-light5"
                      >
                        {language.branch}
                      </label>
                      <input
                        type="text"
                        id="branch"
                        className="form-control rounded-3"
                        placeholder={language.branch}
                        value={user?.school?.name}
                        required
                        disabled
                      />
                    </Col>
                    <Col xl={6} lg={6} className="mt-3">
                      <label htmlFor="grade" className="form-label text-light5">
                        {language.grade}
                      </label>
                      <input
                        type="text"
                        id="grade"
                        className="form-control rounded-3"
                        placeholder={language.grade}
                        value={user?.class?.name}
                        required
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </section>
    </Layout>
  );
}
